import { render, staticRenderFns } from "./VerticalLayout.vue?vue&type=template&id=e57fdcd0"
import script from "./VerticalLayout.vue?vue&type=script&lang=js"
export * from "./VerticalLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports